"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactsTableConf = void 0;
var constants_1 = require("containers/TableMaker/constants");
var SaasButton_1 = __importDefault(require("./CellComponents/SaasButton"));
var ServiceSelect_1 = __importDefault(require("./CellComponents/ServiceSelect"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG;
exports.contactsTableConf = {
    headersMap: { name: 'Contact/Vendor name', isNotSaas: 'Is Not SaaS', serviceId: 'Tool' },
    cells: [
        { cell: { width: XL }, truncate: {}, field: 'name' },
        {
            cell: { width: XL, isFlexCenter: true, offset: 'left' },
            field: 'serviceId',
            noSort: true,
            stopPropagation: true,
            renderComponent: ServiceSelect_1.default,
        },
        { cell: { width: LG, textAlign: 'right' }, field: 'isNotSaas', renderComponent: SaasButton_1.default },
    ],
    extractors: { nameLength: function (c) { var _a; return (_a = c === null || c === void 0 ? void 0 : c.name) === null || _a === void 0 ? void 0 : _a.length; } },
};
